import { Card } from 'react-bootstrap'
import { PaymentAlert } from 'api/common/types'
import { useNavigate } from 'react-router-dom'
import { PaymentStatusForPaymentAlert } from 'api/common/constants'
import AlertIcon from '../images/icon_alert.svg'

interface Props {
  paymentAlert: PaymentAlert
}

export const PaymentAlertCard: React.FC<Props> = ({ paymentAlert }) => {
  const navigate = useNavigate()
  const { positionNumber, paymentStatus } = paymentAlert
  return (
    <Card body className="border-1 shadow-sm mb-3 rounded-1">
      <div className="d-flex align-items-center">
        <div className="text-center" style={{ width: '15%' }}>
          <img src={AlertIcon} alt="alert" />
        </div>
        <div style={{ width: '85%', paddingLeft: 20 }}>
          <div className="font-15">{positionNumber === 1 ? 'メインポジション' : `サブポジション${positionNumber - 1}`}</div>
          {paymentStatus === PaymentStatusForPaymentAlert.shortage && <div className="font-15">入金不足となっています</div>}
          {paymentStatus === PaymentStatusForPaymentAlert.excess && <div className="font-15">過剰入金となっています</div>}
          <div className="font-12">下記より事務局までお問い合わせください</div>
          <button className="border-0 bg-transparent p-0 font-15 text-primary" onClick={() => navigate('/contactUs')} aria-label="問い合わせフォーム">
            問い合わせフォーム
          </button>
        </div>
      </div>
    </Card>
  )
}
